/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFlashOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m2.707 1.293 20 20-1.414 1.414-5.17-5.17L11 22.802V15H.89l5.713-6.983-5.31-5.31zM13 14.413V18l1.703-1.883zM13.413 9h9.697l-4.364 5.333-1.421-1.421L18.89 11l-3.477-.001zm-5.39.438L5.11 13h6.476zM13 1.198v7.389l-2-2-.354-.354-1.421-1.421z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFlashOff as FlashOff };
